import { useNavigate } from 'react-router-dom';
import React from 'react';

import styles from '../../assets/styles/AppHome/QuickLinksCard.module.scss';
import { QuickLinksComponent as QLC } from '../../components/Home';
import constant from '../../utils/constant';
import { userStore } from '../../stores';
import { MimaToastUtil } from '../../components';
import DashboardLinkCopy from './DashboardLinkCopy';

const QuickLinksCard = ({ viewReport }) => {
	const navigate = useNavigate();
	const isOnboardingDone = path => {
		if (userStore.isOnBoardingDone === 'false') {
			MimaToastUtil.error({
				message: constant.OnboardingRequired,
			});
			localStorage.setItem(constant.RoutePath, constant.Routes.Invoice);
			return navigate(constant.Routes.OnboardingStageOne);
		}
		return navigate(path);
	};

	const referrerCode = userStore.user?.referrerCode;
	const referralLink = `https://app.mimapay.africa/signup?referrerCode=${referrerCode}`;

	return (
		<div className={styles.ql}>
			<DashboardLinkCopy
				title="Your Referral Link"
				link={referralLink}
				copyOnly
			/>
			<h4 className={styles.ql__title}>Quick Links</h4>
			<nav className={styles.ql__content}>
				<QLC
					title="Create Payment Link"
					onClick={() => navigate(constant.Routes.PaymentLink)}
				/>
				<QLC
					title="Create Booking Link"
					onClick={() => navigate(constant.Routes.Booking)}
				/>

				<QLC
					title="Send Invoice/Receipt"
					onClick={() => {
						isOnboardingDone(constant.Routes.Invoice);
					}}
				/>
				<QLC
					title="Add Customer"
					onClick={() => navigate(constant.Routes.Customer)}
				/>

				<QLC
					title="Send Money"
					onClick={() => {
						isOnboardingDone(constant.Routes.Wallet);
					}}
				/>
			</nav>
		</div>
	);
};

export default QuickLinksCard;
